import React from 'react';
import ReactDOM from 'react-dom';
// Must be first: this is the module that calls Amplify.configure and builds the
// shared GraphQL client, and v6's generateClient() throws if it runs before
// configure. It used to happen as a side effect of importing user-provider.
import './amplify';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { UserProvider } from './user-provider';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { mark } from './perf';

mark('app:boot');

// The API sleeps after 15 idle minutes on Render's free plan and takes ~15 s to
// wake. Nothing on the sign-in path needs it (Cognito and AppSync are AWS), so
// poke it now and let it spin up while the user signs in or the box loads.
fetch('/api/health', { cache: 'no-store' }).catch(() => {});

ReactDOM.render(
  <UserProvider>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </UserProvider>,
  document.getElementById('root')
);
